import React from "react";
import { CONSTANTS } from "consts";
import useHandleActivePage from "utils/useHandleActivePage";
import { handleRenderRouteElement } from "../useRouteElement.hook";
import { IRouteItem } from "routes/useRouteElement.constant";

interface IWrapperProfile{
    routes: IRouteItem[];
}

const WrapperProfile = ({ routes }: IWrapperProfile) => {
    useHandleActivePage(CONSTANTS.SIDEBAR_PAGEID.PROFILE);

    return (
        <div className="page-content">{handleRenderRouteElement(routes)}</div>
    );
};
export default WrapperProfile;
